import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";
import {
  LinkEntityRequest,
  LinkEntityResponse,
  UnlinkEntityRequest,
  UnlinkEntityResponse,
} from "common247";

/**
 * Links two entities bidirectionally (e.g. Memory <-> Contact, Memory <-> Group, Media <-> Contact, Media <-> Group).
 *
 * @param {FirebaseServices} services - Initialized Firebase client services.
 * @param {LinkEntityRequest} params - Source and target entity link details.
 * @returns {Promise<LinkEntityResponse>} Operation status.
 */
export async function linkEntity(
  services: FirebaseServices,
  params: LinkEntityRequest
): Promise<LinkEntityResponse> {
  return callFunction<LinkEntityRequest, LinkEntityResponse>(
    services,
    "linkEntityFunc",
    params
  );
}

/**
 * Unlinks two entities bidirectionally.
 *
 * @param {FirebaseServices} services - Initialized Firebase client services.
 * @param {UnlinkEntityRequest} params - Source and target entity unlink details.
 * @returns {Promise<UnlinkEntityResponse>} Operation status.
 */
export async function unlinkEntity(
  services: FirebaseServices,
  params: UnlinkEntityRequest
): Promise<UnlinkEntityResponse> {
  return callFunction<UnlinkEntityRequest, UnlinkEntityResponse>(
    services,
    "unlinkEntityFunc",
    params
  );
}
